<template>
    <div>

        <form ref="filterForm">

            <main class="products-page">
                <div class="container-xl">
                    <div class="wrapper">

                        <aside class="sidebar">
                            <sidebar-categories
                                :categories="categories"
                                :category="category"
                            >
                            </sidebar-categories>

                            <price-slider-filter :sum="sum"
                                                 @onOrderChanged="filterChanged"
                            >
                            </price-slider-filter>
                        </aside>

                        <section class="products-listing">

                            <div class="row align-items-end">
                                <div class="text hidden-md-down col-md-8">
                                    <category-info :category="category"></category-info>
                                </div>
                                <div class="col-md-4">
                                    <sorting-filter @onOrderChanged="filterChanged"></sorting-filter>
                                </div>
                            </div>

                            <div class="row gx-2">
                                <div class="js-load-products"
                                     v-if="products.length > 0"
                                     v-html="products"
                                >
                                </div>
                            </div>
                            <div class="js-load-pagination"
                                 v-if="pagination.length > 0"
                                 v-html="pagination"
                            >
                            </div>
                        </section>

                    <!--<color-filter @onOrderChanged="filterChanged"></color-filter>-->
                    </div>
                </div>
            </main>

        </form>

    </div>
</template>

<script>
    import SortingFilter from './filter/SortingFilter';
    //import ColorFilter from './filter/ColorFilter';
    import SidebarCategories from "./listing/SidebarCategories";
    import CategoryInfo from "./listing/CategoryInfo";
    import PriceSliderFilter from "./filter/PriceSliderFilter";

    export default {
        props: {
            route: {
                required: true,
                type: String
            },
            categories: {
                type: Array
            },
            category: {
                type: Object
            },
            sum: {
                type: Object
            }
        },

        data() {
            return {
                products: '',
                pagination: '',
                requestData: [],
                parameters: {},
            }
        },

        mounted() {
            this.$root.$emit(
                'setValuesFromParameters',
                this.getParametersFromHash(window.location.hash.substring(1))
            )

            if ( window.location.hash && window.location.href.indexOf('kategoria') > -1 )
                this.startFilter();
            else
                this.filter();
        },

        methods: {
            startFilter() { this.sendAjax(this.getParametersFromHash(window.location.hash.substring(1)));},

            filter(data, page) { this.sendAjax(data, page); },

            sendAjax(data, page = null) {

                this.$root.$emit('filterProductsStart');

                if ( page !== null )
                    data.append('page', page)

                axios.post(this.route, data)
                    .then(response => {
                        this.products = response.data.products;
                        this.pagination = response.data.pagination;

                        setTimeout( () => {

                            document.querySelectorAll('.js-next-page').forEach( item => {
                                item.addEventListener('click', (e) => {
                                    e.preventDefault();
                                    let page = item.getAttribute('data-page');
                                    this.setHashParam('page', page);
                                    this.filterChanged(page);
                                    this.scrollToTop(500);
                                })
                            })

                        }, 250)

                        this.$root.$emit('filterProductsDone');
                    })
                    .catch(response => console.error(response))
            },

            filterChanged(page) {
                let formData = new FormData(this.$refs.filterForm);

                this.setHashForFiltering(formData);

                this.filter(formData, page);
            },

            setHashForFiltering(formData) {

                formData.forEach((value, key) => {
                    if ( value.includes('€') )
                       value = value.replace('€', '');

                    this.setHashParam(key, value);
                });
            },

            setHashParam(hashParameterName, hashParameterValue) {
                // create dummy url
                let theURL = new URL('https://dummy.com');
                // copy current hash-parameters without the '#' AS search-parameters
                theURL.search = window.location.hash.substring(1);
                // set or update value with the searchParams-API
                theURL.searchParams.set( hashParameterName, hashParameterValue );
                // Write back as hashparameters
                window.location.hash = theURL.searchParams;
            },

            getParametersFromHash( hash ) {
                let pieces = hash.split('&'), data = {}, i, parts;

                // process each query pair
                for ( i = 0; i < pieces.length; i++ ) {
                    parts = pieces[i].split('=');
                    if ( parts.length < 2 ) {
                        parts.push('');
                    }
                    data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                }

                return data;
            },

            scrollToTop (duration) {

                // cancel if already on top
                if (document.scrollingElement.scrollTop === 0) return;

                const totalScrollDistance = document.scrollingElement.scrollTop;
                let scrollY = totalScrollDistance, oldTimestamp = null;

                function step (newTimestamp) {

                    if ( oldTimestamp !== null ) {
                        // if duration is 0 scrollY will be -Infinity
                        scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;

                        if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;

                        document.scrollingElement.scrollTop = scrollY;
                    }

                    oldTimestamp = newTimestamp;
                    window.requestAnimationFrame(step);
                }
                window.requestAnimationFrame(step);
            }
        },

        components: {
            PriceSliderFilter,
            CategoryInfo,
            SidebarCategories,
            SortingFilter,
            //ColorFilter
        }
    }
</script>
